<script>
  import {getCookie, setCookie, delCookie} from '@/util/methods';

  const COOKIE_KEY = 'affiliate_code';
  const QUERY_KEY = 'a';

  export default {
    render() {
    },
    data() {
      return {
        affiliate: {}
      }
    },
    computed: {
      validityDate() {
        return this.get(this.affiliate.data, 'data.affiliateExternal.validityDate');
      }
    },
    async beforeMount() {
      const code = this._getParameterByName(QUERY_KEY);
      if( code ) {
        this.affiliate = await this.$http.get(`/user/v1/affiliate/external/${code}`);
      }else {
        this.affiliate = {};
      }
      if (this.get(this.affiliate.data, 'data.affiliateExternal.type') === 'LINK') {
        this.update()
      } else if (window) {
        //delCookie(COOKIE_KEY)
      }
    },
    methods: {
      update() {
        const code = this._getParameterByName(QUERY_KEY);
        if (code && window) {
          setCookie(COOKIE_KEY, code, this.validityDate);
        }
      },
      _getParameterByName(name, url) {
        if (!url) url = window ? window.location.href : this.$route.fullPath;
        name = name.replace(/[\[\]]/g, '\\$&');
        const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
          results = regex.exec(decodeURIComponent(url));
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
      }
    }
  }
</script>
